// extracted by mini-css-extract-plugin
export var parcelRow = "_q9-0";